import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Inject admin-managed tracking HTML into <head> on every public page.
 * Cleans up its own injected nodes on unmount so route changes don't dupe scripts.
 */
export default function useTrackingScripts() {
  useEffect(() => {
    let injected = [];
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/tracking`);
        const html = (data && data.html) || "";
        if (!html.trim() || cancelled) return;
        const tpl = document.createElement("template");
        tpl.innerHTML = html;
        // Re-create <script> nodes so they execute (template fragments don't run scripts)
        const nodes = Array.from(tpl.content.childNodes);
        nodes.forEach((n) => {
          if (n.nodeType === 1 && n.tagName === "SCRIPT") {
            const s = document.createElement("script");
            Array.from(n.attributes).forEach((a) => s.setAttribute(a.name, a.value));
            s.text = n.text;
            s.setAttribute("data-np-tracking", "1");
            document.head.appendChild(s);
            injected.push(s);
          } else if (n.nodeType === 1) {
            n.setAttribute && n.setAttribute("data-np-tracking", "1");
            document.head.appendChild(n);
            injected.push(n);
          }
        });
      } catch {
        /* silent — tracking is optional */
      }
    })();
    return () => {
      cancelled = true;
      injected.forEach((el) => {
        try { el.remove(); } catch { /* noop */ }
      });
    };
  }, []);
}
